// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"dd7f481b","661":"e8065004"}[chunkId] + ".chunk.js";
};